import React, { useRef, useState, useEffect } from 'react';
import { shape, object, string, bool } from 'prop-types';
import classnames from 'classnames';
import { ConfigMenuItemProps, ConfigLevelProps } from '../../../../types';
import { AMOUNT_ITEMS_TO_SPLIT, AGENCIES_BANNER_CATEGORY_IDS } from '../../../../constants';
import { MODES, overflowHandler } from '../../../../utils';
import MenuItem from '../../MenuItem';
import AgenciesBannerPanel from '../../AgenciesBannerPanel';

const DefaultPanel = ({ config, item, eventTracker, mode, shouldShowPostBriefCta }) => {
    const [overflowStyling, setOverflowStyling] = useState({});
    const ref = useRef(null);
    const { level_2 = {} } = config;
    const { id, displayName } = item;
    const items = level_2[id];
    const hasThreeColumnClass = !!items && items.length > AMOUNT_ITEMS_TO_SPLIT;
    const categoryId = Number(item?.reportData?.categoryId);
    const showAgenciesBanner = AGENCIES_BANNER_CATEGORY_IDS.includes(categoryId);

    useEffect(() => {
        overflowHandler(ref, setOverflowStyling, shouldShowPostBriefCta);
    }, [shouldShowPostBriefCta]);

    return (
        <ul
            ref={ref}
            style={overflowStyling}
            className={classnames(
                'menu-panel',
                { 'three-columns-menu': hasThreeColumnClass },
                { 'has-agencies-banner': showAgenciesBanner }
            )}
        >
            {items &&
                items.map((item) => (
                    <MenuItem
                        key={item.id}
                        item={item}
                        context={displayName}
                        eventTracker={{ ...eventTracker, entry: item.displayName }}
                    />
                ))}
            {showAgenciesBanner && (
                <AgenciesBannerPanel
                    eventTracker={eventTracker}
                    item={item}
                    isWide={hasThreeColumnClass}
                    isPro={mode === MODES.PRO}
                />
            )}
        </ul>
    );
};

DefaultPanel.propTypes = {
    config: shape({
        level_2: ConfigLevelProps,
        level_3: ConfigLevelProps,
    }),
    item: ConfigMenuItemProps,
    eventTracker: object,
    mode: string,
    shouldShowPostBriefCta: bool,
};

export default DefaultPanel;
